// 用户评价数据配置文件
// 可以根据实际需求修改这些数据，或者从API获取

import { TwitterCardData } from '../TwitterSection';
import { TikTokVideoData } from '../TikTokSection';
import { InstagramVideoData } from '../InstagramSection';

/**
 * Twitter 评价数据
 * 注意：实际使用时需要替换为真实的图片和链接
 */
export const twitterTestimonials: TwitterCardData[] = [
  {
    id: '1',
    userName: 'Marlon Daily',
    userHandle: '@MarlonDaily',
    userAvatar: '/images/testimonials/twitter-user-0.png',
    content:
      'Top Spanish Influencer 🌸 Lola Lolita 🌸 recently followed Marlon on IG 😭 \n\nFor context, she is Marta Diaz’s opp 😂',
    image: '/images/testimonials/1.webp', // 单张图片
    link: 'https://x.com/MarlonDaily/status/1985048492943835554',
  },
  {
    id: '2',
    userName: 'InfoRoma24',
    userHandle: '@inforoma24',
    userAvatar: '/images/testimonials/twitter-user-1.png',
    content:
      'Nelle ultime ore si sta infuocando li nome di Claudio #Echeverri a #Roma. Il motivo? Il calciatore ha commentato per la prima volta un post di Matias #Soulé, dopo #LensRoma. Successivamente Paulo #Dybala ha iniziato a seguire il calciatore del #ManchesterCity su IG.',
    image: '/images/testimonials/2.webp', // 单张图片
    link: 'https://x.com/inforoma24/status/1952036761418584527',
  },
  {
    id: '3',
    userName: 'robert',
    userHandle: '@sake_robert',
    userAvatar: '/images/testimonials/twitter-user-2.png',
    content: "guarda un po' chi ha appena iniziato a seguire il nostro caro Paulo Dybala...",
    image: '/images/testimonials/3.webp', // 单张图片
    link: 'https://x.com/sake_robert/status/1952005743236038708',
  },
  {
    id: '4',
    userName: 'Football Confidential',
    userHandle: '@footballconfid1',
    userAvatar: '/images/testimonials/twitter-user-3.png',
    content: "Morgan Rogers just started following Tottenham's James Maddison on Insta…",
    image: '/images/testimonials/4.webp', // 单张图片
    link: 'https://x.com/footballconfid1/status/1962195059727618403',
  },
  {
    id: '5',
    userName: 'Ozzny',
    userHandle: '@Ozzny_CS2',
    userAvatar: '/images/testimonials/twitter-user-4.png',
    content:
      "I don't know how accurate this 'tracking tool' is, how recent the follow was or if this means anything at all \n\nBut... what if? 👀",
    image: '/images/testimonials/5.webp', // 单张图片
    link: 'https://x.com/Ozzny_CS2/status/1967304824447553827',
  },
  {
    id: '6',
    userName: 'Dolphin Radar',
    userHandle: '@DolphinRadar',
    userAvatar: '/images/testimonials/twitter-user-6.png',
    content:
      "Lisa's Birthday Dance with Jennie! Download Their Story Before It Disappears!\n\n Use DolphinRadar to quickly download Instagram stories—no more worrying about missing out when the 24-hour timer runs out.\n https://dolphinradar.com\n#BLACKPINK  #LISA   #JENNIE  #jenniekim",
    image: '/images/testimonials/6.webp', // 单张图片
    link: 'https://x.com/DolphinRadar/status/1880177081692414004',
  },
];

/**
 * TikTok 视频数据
 * 注意：需要准备视频文件和缩略图
 */
export const tiktokTestimonials: TikTokVideoData[] = [
  {
    id: '1',
    username: 'm1cainchausti',
    userHandle: 'm1cainchausti',
    videoUrl: '/videos/tiktok-video-1.mp4',
    thumbnailUrl: '/images/testimonials/tiktok-thumb-1.webp',
    link: 'https://www.tiktok.com/@m1cainchausti/video/7559822124257414411?is_from_webapp=1&web_id=7530219317465073166',
  },
  {
    id: '2',
    username: 'ellieebellieeee',
    userHandle: 'ellieebellieeee',
    videoUrl: '/videos/tiktok-video-2.mp4',
    thumbnailUrl: '/images/testimonials/tiktok-thumb-2.webp',
    link: 'https://www.tiktok.com/@ellieebellieeee/video/7502446894057065771?is_from_webapp=1&web_id=7530219317465073166',
  },
  {
    id: '3',
    username: 'pportk',
    userHandle: 'pportk',
    videoUrl: '/videos/tiktok-video-3.mp4',
    thumbnailUrl: '/images/testimonials/tiktok-thumb-3.webp',
    link: 'https://www.tiktok.com/@pportk/video/7529923897073126664?is_from_webapp=1&web_id=7530219317465073166',
  },
  {
    id: '4',
    username: 'noodleyasha',
    userHandle: 'noodleyasha',
    videoUrl: '/videos/tiktok-video-4.mp4',
    thumbnailUrl: '/images/testimonials/tiktok-thumb-4.webp',
    link: 'https://www.tiktok.com/@noodleyasha/video/7508878554298453256',
  },
  {
    id: '5',
    username: 'salehere',
    userHandle: 'salehere',
    videoUrl: '/videos/tiktok-video-5.mp4',
    thumbnailUrl: '/images/testimonials/tiktok-thumb-5.webp',
    link: 'https://www.tiktok.com/@salehere/video/7549956503675981074',
  },
  {
    id: '6',
    username: 'memorieswiththemulkeys',
    userHandle: 'memorieswiththemulkeys',
    videoUrl: '/videos/tiktok-video-6.mp4',
    thumbnailUrl: '/images/testimonials/tiktok-thumb-6.webp',
    link: 'https://www.tiktok.com/@memorieswiththemulkeys/video/7544003393686179102?is_from_webapp=1&web_id=7530219317465073166',
  },
  {
    id: '7',
    username: 'aaadamarii',
    userHandle: 'aaadamarii',
    videoUrl: '/videos/tiktok-video-7.mp4',
    thumbnailUrl: '/images/testimonials/tiktok-thumb-7.webp',
    link: 'https://www.tiktok.com/@aaadamarii/video/7560482599865552135?is_from_webapp=1&web_id=7530219317465073166',
  },
  {
    id: '8',
    username: 'user666136965',
    userHandle: 'user666136965',
    videoUrl: '/videos/tiktok-video-8.mp4',
    thumbnailUrl: '/images/testimonials/tiktok-thumb-8.webp',
    link: 'https://www.tiktok.com/@user666136965/video/7534796708543253791?is_from_webapp=1&web_id=7530219317465073166',
  },
  {
    id: '9',
    username: 'taliaholtz',
    userHandle: 'taliaholtz',
    videoUrl: '/videos/tiktok-video-9.mp4',
    thumbnailUrl: '/images/testimonials/tiktok-thumb-9.webp',
    link: 'https://www.tiktok.com/@taliaholtz/video/7470976276170378514?is_from_webapp=1&web_id=7530219317465073166',
  },
  {
    id: '10',
    username: 'allyfantaisies',
    userHandle: 'allyfantaisies',
    videoUrl: '/videos/tiktok-video-10.mp4',
    thumbnailUrl: '/images/testimonials/tiktok-thumb-10.webp',
    link: 'https://www.tiktok.com/@allyfantaisies/video/7545460604962606358?is_from_webapp=1&web_id=7530219317465073166',
  },
];

/**
 * Instagram 视频数据
 * 注意：需要准备视频文件和缩略图
 */
export const instagramTestimonials: InstagramVideoData[] = [
  {
    id: '1',
    username: 'pportk',
    userHandle: 'pportk',
    videoUrl: '/videos/instagram-video-1.mp4',
    thumbnailUrl: '/images/testimonials/instagram-thumb-1.webp',
    link: 'https://www.instagram.com/reel/DMahvaLTKLI/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D',
  },
  {
    id: '2',
    username: 'pinkieloveforever',
    userHandle: 'pinkieloveforeer',
    videoUrl: '/videos/instagram-video-2.mp4',
    thumbnailUrl: '/images/testimonials/instagram-thumb-2.webp',
    link: 'https://www.instagram.com/reel/DN1LI7J0A0l/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D',
  },
  {
    id: '3',
    username: 'siennabelic',
    userHandle: 'siennabelic',
    videoUrl: '/videos/instagram-video-3.mp4',
    thumbnailUrl: '/images/testimonials/instagram-thumb-3.webp',
    link: 'https://www.instagram.com/reel/DOGl2U-jBDo/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D',
  },
];

/**
 * 从API获取数据的示例函数
 * 可以根据实际API接口进行调整
 */
export async function fetchTestimonialsFromAPI() {
  try {
    const response = await fetch('/api/testimonials');
    if (!response.ok) {
      throw new Error('Failed to fetch testimonials');
    }
    const data = await response.json();
    return {
      twitter: data.twitter || twitterTestimonials,
      tiktok: data.tiktok || tiktokTestimonials,
      instagram: data.instagram || instagramTestimonials,
    };
  } catch (error) {
    console.error('Error fetching testimonials:', error);
    // 返回默认数据
    return {
      twitter: twitterTestimonials,
      tiktok: tiktokTestimonials,
      instagram: instagramTestimonials,
    };
  }
}
